export default __webpack_public_path__ + "static/media/mini-gold-card.35d76515.png";